import { render, staticRenderFns } from "./MSelectFrame.vue?vue&type=template&id=31bfafc0&"
import script from "./MSelectFrame.vue?vue&type=script&lang=ts&"
export * from "./MSelectFrame.vue?vue&type=script&lang=ts&"
import style0 from "./MSelectFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports